interface EpisodeListProps {
  episodes: number;
  latestEpisode: number;
  activeEpisode: number;
  onSelect: (episode: number) => void;
}

export default function EpisodeList({ episodes, latestEpisode, activeEpisode, onSelect }: EpisodeListProps) {
  const items = Array.from({ length: episodes }, (_, index) => index + 1);

  return (
    <div>
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2">
        {items.map((episode) => {
          const locked = episode > latestEpisode;
          const active = episode === activeEpisode;
          return (
            <button
              key={episode}
              type="button"
              disabled={locked}
              onClick={() => onSelect(episode)}
              className={`h-10 rounded-md text-sm font-medium flex items-center justify-center gap-1 whitespace-nowrap transition-colors ${
                active
                  ? 'bg-primary-500 text-background-50 cursor-pointer'
                  : locked
                    ? 'bg-background-100 text-foreground-400 cursor-not-allowed'
                    : 'bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600 cursor-pointer border border-background-200'
              }`}
            >
              {locked && <i className="ri-lock-line text-xs"></i>}
              {episode}
            </button>
          );
        })}
      </div>
      <p className="mt-3 text-xs text-foreground-500">
        当前选择：第 <span className="text-primary-600 font-semibold">{activeEpisode}</span> 集
        {latestEpisode < episodes && ` · 已更新至第 ${latestEpisode} 集，未更新剧集暂不可选择`}
      </p>
    </div>
  );
}